function RenderDemoGraphics({ demodata, id }) {
  return (
    <div className="smart-tag-bdy content-line-break" id={'sectionVal_' + id}>
      <div className="smart-tag-bdy-rw">
        <span style={{ fontSize: '21px' }}>
          {demodata?.demographics?.patientName} (#
          {demodata?.demographics?.chartNo})
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span>
          {demodata?.demographics?.age} {demodata?.demographics?.gender}
          {demodata?.demographics?.dob && (
            <>
              ,&nbsp;<b>DOB</b>:{demodata?.demographics?.dob}
            </>
          )}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span>
          {demodata?.demographics?.address && (
            <>
              <b>Address:</b> {demodata?.demographics?.address}
            </>
          )}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span>
          {demodata?.demographics?.email && (
            <>
              <b>Email</b>: {demodata?.demographics?.email}
            </>
          )}
          {demodata?.demographics?.phoneLabel &&
            demodata?.demographics?.phone && (
              <>
                {demodata?.demographics?.email ? (
                  <>
                    ,&nbsp;<b>{demodata?.demographics?.phoneLabel}</b>:{' '}
                    {demodata?.demographics?.phone}
                  </>
                ) : (
                  <>
                    <b>{demodata?.demographics?.phoneLabel}</b>:{' '}
                    {demodata?.demographics?.phone}
                  </>
                )}
              </>
            )}
        </span>
      </div>
      <div className="smart-tag-bdy-rw">
        <span>
          {demodata?.demographics?.race && (
            <>
              <b>Race</b>: {demodata?.demographics?.race}
            </>
          )}
          {demodata?.demographics?.raceGroup && (
            <>
              ,&nbsp;<b>Race Group</b>: {demodata?.demographics?.raceGroup}
            </>
          )}
          {demodata?.demographics?.ethincity && (
            <>
              ,&nbsp;<b>Ethnicity</b>: {demodata?.demographics?.ethincity}
            </>
          )}
          {demodata?.demographics?.ethincityGroup && (
            <>
              ,&nbsp;<b>Ethnicity Group</b>:{' '}
              {demodata?.demographics?.ethincityGroup}
            </>
          )}
        </span>
      </div>
    </div>
  );
}

export default RenderDemoGraphics;
